export default __webpack_public_path__ + "static/User2-99ba4499174005dc561fa2b8a4f4f04f.png";